import { Injectable } from '@angular/core';
import { FilterDefinitionItem } from '../../core/model/filter-definition-item';
import { LanguageService } from '../../core/service/language.service';
import { LettingFeature, LettingFeatureReferenceType } from '../model/letting-feature';

const lettingFeatureFilterPrefix = 'lettingFeatureFilters_';
const anyReferenceType = 'any-reference-type';

@Injectable()
export class LettingFeatureFilterHelper {
  constructor(private readonly languageService: LanguageService) {}

  generateLettingFeatureFilters(features: LettingFeature[], definition: any): FilterDefinitionItem[] {
    return features.map(feature => {
      const name = `${lettingFeatureFilterPrefix}${feature.id}`;
      const savedFilter = definition.lettingFeatureFilters?.find(filter => filter.lettingFeatureId === feature.id);
      const value = savedFilter?.matchAnyReferenceType ? anyReferenceType : savedFilter?.referenceType ?? null;

      return new FilterDefinitionItem<any, string | number>(
        this.getCaption(feature),
        name,
        value,
        [
          { caption: 'LETTING_FEATURE.FILTER_ALL_REFERENCE_TYPES', value: anyReferenceType },
          { caption: 'RENTAL_OBJECT.LETTING_FEATURES.INCLUDED', value: LettingFeatureReferenceType.Included },
          { caption: 'LETTING_FEATURE.FILTER_NOT_INCLUDED', value: LettingFeatureReferenceType.NotIncluded },
        ],
        definition.selectedFields?.includes(name)
      );
    });
  }

  applyLettingFeatureFilters(filterState: any): void {
    filterState.lettingFeatureFilters = Object.keys(filterState)
      .filter(key => key.startsWith(lettingFeatureFilterPrefix) && filterState[key] !== null && filterState[key] !== undefined && filterState[key] !== '')
      .map(key => ({
        lettingFeatureId: key.substring(lettingFeatureFilterPrefix.length),
        referenceType: filterState[key] === anyReferenceType ? null : filterState[key],
        matchAnyReferenceType: filterState[key] === anyReferenceType,
      }));
  }

  private getCaption(feature: LettingFeature): string {
    const currentTranslation = feature.phrase?.find(translation => translation.cultureName === this.languageService.currentCultureLang);
    const caption = currentTranslation?.translationText || feature.phrase?.find(translation => !!translation.translationText)?.translationText || '';
    return `${caption} (${this.languageService.instant('LETTING_FEATURE.FILTER_SUFFIX')})`;
  }
}
